import { mode, transparentize } from '@chakra-ui/theme-tools';
const parts = ['container', 'icon'];
const baseStyle = {
    container: {
        pl: 3,
        pr: 4,
        paddingY: 3,
        fontSize: 'md',
        lineHeight: 'base',
    },
    icon: {
        w: 5,
        h: 5,
    },
};
const getColors = (props) => {
    const { theme } = props;
    const status = props.status;
    switch (status) {
        case 'info': {
            return {
                background: mode(transparentize('blue.400', 0.08)(theme), transparentize('blue.600', 0.08)(theme))(props),
                borderColor: mode('blue.500', 'blue.400')(props),
                iconColor: mode('blue.500', 'blue.300')(props),
            };
        }
        case 'success': {
            return {
                background: mode(transparentize('green.400', 0.08)(theme), transparentize('green.600', 0.08)(theme))(props),
                borderColor: 'green.500',
                iconColor: mode('green.500', 'green.400')(props),
            };
        }
        case 'warning': {
            return {
                background: mode(transparentize('yellow.300', 0.08)(theme), transparentize('yellow.500', 0.08)(theme))(props),
                borderColor: 'yellow.400',
                iconColor: mode('yellow.400', 'yellow.300')(props),
            };
        }
        case 'error': {
            return {
                background: mode(transparentize('red.400', 0.08)(theme), transparentize('red.600', 0.08)(theme))(props),
                borderColor: 'red.500',
                iconColor: mode('red.500', 'red.400')(props),
            };
        }
    }
};
const getOutlineStyle = (props) => {
    const { background, borderColor, iconColor } = getColors(props);
    return {
        container: {
            background,
            color: mode(`gray.600`, `white`)(props),
            border: '1px solid',
            borderColor,
            borderRadius: 'base',
        },
        icon: {
            color: iconColor,
        },
    };
};
const variants = {
    outline: getOutlineStyle,
};
const defaultProps = {
    variant: 'outline',
};
export default {
    parts,
    baseStyle,
    variants,
    defaultProps,
};
//# sourceMappingURL=alert.js.map